<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       height="48"
       width="48"
       viewBox="0 0 48 48">
    <path d="M22.5 38V25.5H10v-3h12.5V10h3v12.5H38v3H25.5V38Z"
          class="fill"/>
  </svg>
</template>

<script>
/**
 * SVG icon.
 */
export default {
  name: 'SvgPlus',
  props: ['fill', 'stroke']
}
</script>

